/**
 * desc: 添加监控库
 * dev: huaqiangj
 */

import Vue from 'vue'
import Cookies from 'js-cookie'
import tjCookie from './tjCookie'
import mayiCookie from './mayiCookie'
import urlHelper from '@lib/utils/urlHelper'
import { getChannelInfo } from '@common-libs/tj-channel'
import { getPlatform } from '@common-libs/tj-utils/platform'
import { Sniff } from './q_sniff'
import { queryString } from '@common-libs/utils/url-helper'

// cms-tujia和cms-mayi环境不同，userid获取也不同
let userId = process.env.VUE_APP_LOCAL === 'M' ? mayiCookie.getUserId() : tjCookie.getUserId()
const code = tjCookie.getTujiaCode()
const codeSite = tjCookie.getTujiaCodeSite()
const outcode = tjCookie.getOutcode()
const tujiaUtm = tjCookie.getTujiaUtm()
const channelInfo = getChannelInfo()
let channel = channelInfo.channelId
const channelToken = tjCookie.getChannelToken()
let unionid = ''
try {
  if (channelToken) {
    unionid = JSON.parse(decodeURIComponent(channelToken))?.unionId
  }
} catch (e) { }
let openid = tjCookie.getOpenId()

if (process.env.VUE_APP_LOCAL === 'Q') {
  userId = (Sniff.uinfo && Sniff.uinfo.uid) || ''
  channel = 'qunar'
  openid = decodeURIComponent(Cookies.get('openId') || '')
  unionid = decodeURIComponent(Cookies.get('unionId') || '')
}
/**
 * 自执行函数，初始化监控库
 */
function initFas() {
  const fas = window._fas

  const params = {
    channel,
    tujia_code: code || queryString('code'),
    tujia_code_site: codeSite,
    outcode,
    utm_source: tujiaUtm,
    platform: getPlatform().platformValue,
    openid,
    unionid
  }

  // 与小程序保持一致
  const uuid = tjCookie.getDeviceId()
  const mpuuid = urlHelper.queryString('mpuuid')
  if (mpuuid && mpuuid !== uuid) {
    params.uid = mpuuid
  }

  // 未加在成功 不执行设置
  fas.setSiteExt(params)
  fas.setUserId(userId)
}
if (window._fas) {
  initFas()
} else {
  window.addEventListener('onFasInit', initFas)
}

/**
[tjReport 业务报警]
@param  {[string]} msg 报警消息，英文，用于报警消息&消息聚合，内容要求可以精确定位这个业务
@param  {[object]} data 报警数据
@param  {[string]} tipMsg 用户提示，非阻断的报警可以使用tips提示
@param  {[string]} altMsg 用户弹层提示，阻断用户操作，需要使用alt，比如必要参数缺少
*/
Vue.prototype.$tjReport = function({ msg, data, tipMsg, altMsg }) {
  if (tipMsg) {
    Vue.prototype.$tips(tipMsg)
  }
  if (altMsg) {
    Vue.prototype.$dialog({
      title: '异常提示',
      message: altMsg,
      showCancelButton: false
    })
  }
  window._fas && window._fas.setCustomError({ message: msg, error: data })
}
